module.exports = __webpack_public_path__ + "img/2666b1f.png";